import type { SampleTestDto } from '@/api';

import { formatDate } from '../../../lib/format';

/** Какой тест в окне: клиент, товар, отгрузка - подпись под заголовком; «№» не отрывается от номера. */
export const describeSampleTest = (test: SampleTestDto): string =>
  `${test.partner.name} · ${test.product.name} · отгрузка №\u00a0${test.shipment.number} от ${formatDate(test.shipment.date)}`;
